export default __webpack_public_path__ + "static/media/IconDesc_SpelevatorPart_5.64.339b28b2.png";